import { createEvent } from '@cobuildlab/react-simple-state';
import {
  PlanListType,
  PlanType,
  PlanStripeCouponListType,
  PlanStripeCouponType,
} from './plan-types';

export const planListEvent = createEvent<PlanListType>({
  initialValue: {
    data: [],
    total: 0,
  },
});

export const planListEventError = createEvent<Error>();

export const fetchPlanEvent = createEvent<PlanType>();
export const fetchPlanEventError = createEvent<Error>();

export const fetchPlanCouponListEvent = createEvent<PlanStripeCouponListType>();
export const fetchPlanCouponListEventError = createEvent<Error>();

export const createPlanCouponEvent = createEvent<PlanStripeCouponType>();
export const createPlanCouponEventError = createEvent<Error>();
